import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '@/utils/api';

export default function GlobalChatWidget() {
  const { workspaceId } = useParams();
  const [hasPineconeFiles, setHasPineconeFiles] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Check if workspace has Pinecone files
  useEffect(() => {
    const checkPineconeFiles = async () => {
      if (!workspaceId) {
        setIsChecking(false);
        return;
      }

      try {
        const response = await api.get('/pinecone/files/workspace', {
          params: {
            workspace_id: parseInt(workspaceId, 10),
          },
        });

        const fileCount = response.data?.data?.count || 0;
        setHasPineconeFiles(fileCount > 0);
      } catch (error) {
        console.error('Error checking Pinecone files for chat:', error);
        setHasPineconeFiles(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkPineconeFiles();
  }, [workspaceId]);

  useEffect(() => {
    // Only initialize chat if there are Pinecone files
    if (isChecking || !hasPineconeFiles) {
      return;
    }

    let chatInstance: any;
    (async () => {
      try {
        try {
          await import('@n8n/chat/style.css');
        } catch {
          void 0;
        }

        const mod: any = await import('@n8n/chat');
        const token = localStorage.getItem('accessToken');

        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
        };
        if (token) headers.Authorization = `Bearer ${token}`;

        const baseWebhookUrl = 'https://nimon.app.n8n.cloud/webhook/84aff568-8ea9-4b66-bdc4-ba0f6b7f05ac/chat';
        const webhookUrl = token
          ? `${baseWebhookUrl}${baseWebhookUrl.includes('?') ? '&' : '?'}jwt=${encodeURIComponent(token)}`
          : baseWebhookUrl;

        const config = {
          webhookUrl,
          mode: 'window',
          webhookConfig: {
            method: 'POST',
            headers,
          },
          metadata: {
            token: token,
          },
        } as any;

        if (typeof mod.createChat === 'function') {
          chatInstance = mod.createChat(config);
        } else if (typeof mod.default === 'function') {
          chatInstance = new mod.default(config);
        }
      } catch (error) {
        console.error('Failed to initialize n8n chat:', error);
      }
    })();

    return () => {
      try {
        if (chatInstance && typeof chatInstance.destroy === 'function') {
          chatInstance.destroy();
        }
      } catch {
        void 0;
      }
    };
  }, [isChecking, hasPineconeFiles]);

  return null;
}
